import React, {Component} from "react";
import Close from "./CloseView";
import {Growl} from "primereact/growl";
import {CloseService} from "../../../service/operation/close/CloseService";
import {Check, Clear} from "@material-ui/icons";

export default class CloseContainer extends Component {
    constructor(props) {
        super(props);

        this.closeService = new CloseService();

        this.loading = this.loading.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.isClose = this.isClose.bind(this);
        this.getValidationClose = this.getValidationClose.bind(this);

        this.state = {
            isLoading: true,
            labelButton: '',
            validationList: '',
        }

        this.isClose();
        this.getValidationClose();
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    isClose() {
        this.loading(true);
        this.closeService.isClose().then(
            response => {
                this.setState({
                    labelButton: response.payload[0] === 0 ? 'Cierre' : 'Regresar Cierre',
                });
                this.loading(false);
            });
    }

    getValidationClose() {
        this.loading(true);
        this.closeService.getValidationClose().then(
            response => {
                this.setState({
                    validationList: response.payload[0],
                });
                this.loading(false);
            });
    }

    formatStatus(rowData) {
        let icon0 = <div><Clear color={"error"}/></div>;
        let icon1 = <div><Check color={"secondary"}/></div>;
        return (rowData['statusValidacion'] === 0  ? icon0 : icon1);
    }

    handleClose() {
        if (this.state.labelButton === 'Cierre') {
            this.closeService.close()
                .then(response => {
                    if(response.message === "Success"){
                        this.growl.show({severity: 'success', summary: 'Éxito.', detail: "Cierre efectuado con éxito"});
                    }else if(response.error.includes("exito") || response.error.includes("éxito")){
                        this.growl.show({severity: 'success', summary: 'Éxito.', detail: "Cierre efectuado con éxito"});
                    } else if (response.error !== '') {
                        this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
                    }
                    this.isClose();
                }
            );
        } else {
            this.closeService.returnClose().then(
                response => {
                    if(response.message === "Success"){
                        this.growl.show({severity: 'success', summary: 'Éxito.', detail: "Regreso de cierre efectuado con éxito"});
                    }else if(response.error.includes("exito") || response.error.includes("éxito")){
                        this.growl.show({severity: 'success', summary: 'Éxito.', detail: "Regreso de cierre efectuado con éxito"});
                    } else if (response.error !== '') {
                        this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
                    }
                    this.isClose();
                }
            );
        }
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <Close
            isLoading={this.state.isLoading}
            messagesGrowl={messagesGrowl}
            labelButton={this.state.labelButton}
            formatStatus={this.formatStatus}
            handleClose={this.handleClose}
            validationList={this.state.validationList}
        />

    }
};